// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__ncyXy","rowsWrapper":"style_rowsWrapper__OFijw","rowWrapper":"style_rowWrapper__p_LAj","edit_wrapper":"style_edit_wrapper__1OMi5"};